import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  FinancialCategory,
  FinancialRequestDetailsHistory,
  FinancialRequestHistoryItemType,
  FinancialRequestStatus,
} from '@pt/models';

@Component({
  selector: 'pu-admin-finance-history-item',
  templateUrl: './history-item.component.html',
  styleUrls: ['./history-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    DatePipe,
  ],
})
export class HistoryItemComponent {
  item = input.required<FinancialRequestDetailsHistory>();
  categories = input.required<FinancialCategory[]>();
  readonly #translateService = inject(TranslateService);

  get value(): string {
    if (this.item().eventType === FinancialRequestHistoryItemType.Status) {
      return this.#translateService
        .instant('dictionary.financialRequestStatuses.' + this.item().status);
    }

    return this.item().historyInfo;
  }

  get status(): FinancialRequestStatus {
    const item = this.item();

    if (item.eventType !== FinancialRequestHistoryItemType.Status) {
      return FinancialRequestStatus.Rejected;
    }

    const map: Partial<Record<FinancialRequestStatus, FinancialRequestStatus>> = {
      [FinancialRequestStatus.Canceled]: FinancialRequestStatus.Canceled,
      [FinancialRequestStatus.Rejected]: FinancialRequestStatus.Canceled,
      [FinancialRequestStatus.InProgress]: FinancialRequestStatus.InProgress,
      [FinancialRequestStatus.New]: FinancialRequestStatus.InProgress,
      [FinancialRequestStatus.Completed]: FinancialRequestStatus.Completed,
    };

    return map[item.status] ?? FinancialRequestStatus.Completed;
  }
}
